import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";
import { Slider } from "ComponentsUI/Sliders";
import { webpTransformer } from "Helpers/ImageManager";
import LazyImage from "ComponentsUI/Image";

const styles = (theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		maxWidth: "100%",
	},
	sliderWrapper: {
		display: "flex",
		justifyContent: "space-between",
		overflow: "hidden",
		borderRadius: 0,
		borderTop: "none",
		borderBottom: "none",
		position: "relative",
	},
	slider: {
		display: "flex",
		flexShrink: 0,
		transition: "transform .5s linear",
		transform: "translate(0,0)",
		position: "relative",
		left: 0,
	},
	sliderItem: {
		height: "50px",
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
		display: "flex",
		alignItems: "center",
		marginRight: "20px",
		padding: "0 16px",
		"&:last-child": {
			marginRight: 0,
		},
	},
	sliderItemLogo: {
		maxHeight: "30px",
		maxWidth: "100px",
		width: "auto",
		marginRight: "19px",
	},
	sliderItemSpeed: {
		fontFamily: theme.fonts.medium,
		fontSize: "24px",
		lineHeight: 1,
		color: theme.palette.colors.darkSlateBlue,
		marginRight: "9px",
	},
	sliderItemNote: {
		fontFamily: theme.fonts.medium,
		fontSize: "10px",
		lineHeight: 1.1,
		letterSpacing: "1.4px",
		color: theme.palette.colors.oneMoreGrey,
		textTransform: "uppercase",
		marginRight: "20px",
	},
	sliderItemDelete: {
		color: theme.palette.colors.lightGrayishViolet,
		fontSize: "16px",
		cursor: "pointer",
	},
	sliderController: {
		transition: "opacity .3s ease .3s",
		transform: "translate3d(0,0,0)",
		opacity: 1,
		backgroundColor: theme.palette.colors.white,
		position: "relative",
		"& span": {
			color: theme.palette.colors.oneMoreGrey,
			fontSize: "24px",
		},
	},
	sliderControllerItem: {
		width: "50px",
		height: "50px",
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0,
		cursor: "pointer",
		maxWidth: "50px",
	},
	sliderControllerShowBorder: {},
	sliderControllerPrev: {
		paddingRight: "20px",
		"&$sliderControllerShowBorder": {
			"&:after": {
				content: "''",
				position: "absolute",
				top: 0,
				bottom: 0,
				right: 0,
				width: "1px",
				backgroundColor: theme.palette.colors.lightGrayishViolet,
			},
		},
	},
	sliderControllerNext: {
		paddingLeft: "20px",
		"&$sliderControllerShowBorder": {
			"&:after": {
				content: "''",
				position: "absolute",
				top: 0,
				bottom: 0,
				left: 0,
				width: "1px",
				backgroundColor: theme.palette.colors.lightGrayishViolet,
			},
		},
	},
	sliderControllerIsHide: {
		opacity: 0.2,
		transition: "opacity .3s ease 0s",
		"& $sliderControllerItem": {
			userSelect: "none",
			cursor: "default",
		},
	},
	addMore: {
		display: "flex",
		alignItems: "center",
		marginLeft: "36px",
		flexShrink: 1000,
	},
	addMoreIcon: {
		width: "24px",
		height: "24px",
		marginRight: "10px",
		fill: theme.palette.colors.lightGrayishViolet,
	},
	addMoreText: {
		fontFamily: theme.fonts.light,
		fontSize: "16px",
		lineHeight: 1,
		color: theme.palette.colors.oneMoreGrey,
		marginTop: "-2px",
		textAlign: "center",
	},
	button: {
		width: "140px",
		marginLeft: "20px",
		flexShrink: 0,
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			padding: "0 60px",
		},
		sliderItem: {
			marginRight: "10px",
		},
		sliderControllerPrev: {
			paddingRight: "10px",
		},
		sliderControllerNext: {
			paddingLeft: "10px",
		},
		sliderControllerIsHide: {
			marginLeft: 0,
		},
		button: {
			marginLeft: "10px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
			justifyContent: "center",
		},
		sliderWrapper: {
			display: "none",
		},
		sliderController: {
			display: "none",
		},
		addMore: {
			marginLeft: 0,
			maxWidth: "50%",
		},
		addMoreIcon: {
			display: "none",
		},
		addMoreText: {
			fontSize: "14px",
			marginTop: 0,
		},
		button: {
			width: "177px",
			marginLeft: 0,
		},
	},
});

class CompareSliderWrapper extends React.Component {
	static defaultProps = {
		tariffs: [],
	};

	removeTariff(item) {
		let slider = this.slider;
		slider.setState({
			offsetSlider: 0,
		});
		slider.refs.slider.style.transform = "translateX(0px)";
		this.props.removeTariff(item);
	}

	generateTariffs() {
		let text = this.props.text;
		let classes = this.props.classes;
		return this.props.tariffs.map((item, index) => {
			let speed = 0;

			if (item.hasOwnProperty("internet") && item.internet !== null) {
				speed = item.internet.speed_in ? item.internet.speed_in : 0;
			}

			return (
				<div key={item.id} className={classes.sliderItem}>
					<LazyImage
						src={webpTransformer(item.provider.logo_2)}
						className={classes.sliderItemLogo}
						alt={item.provider.name}
					/>
					{!!speed && <span className={classes.sliderItemSpeed}>{speed}</span>}
					{!!speed && (
						<span className={classes.sliderItemNote}>
							<div>{text.MB}</div>
							<div>{text.SEC}</div>
						</span>
					)}
					<span
						className={classNames(classes.sliderItemDelete, "icon24", "icon-close")}
						onClick={() => {
							this.removeTariff(item);
						}}
					/>
				</div>
			);
		});
	}

	render() {
		let items = this.generateTariffs();
		let text = this.props.text;
		let classes = this.props.classes;

		return (
			<div className={classes.root}>
				{this.props.tariffs.length > 0 && (
					<Slider
						ref={(slider) => {
							this.slider = slider;
						}}
						classes={classes}
						items={items}
					/>
				)}
				{this.props.tariffs.length == 1 && (
					<div className={classes.addMore}>
						<svg
							className={classes.addMoreIcon}
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="18"
							viewBox="0 0 24 18"
						>
							<path
								d="M731,5643H717a1,1,0,0,1,0-2h14A1,1,0,0,1,731,5643Zm0,4H717a1,1,0,0,1,0-2h14A1,1,0,0,1,731,5647Zm0,4H717a1,1,0,0,1,0-2h14A1,1,0,0,1,731,5651Zm-4,4H717a1,1,0,0,1,0-2h10A1,1,0,0,1,727,5655Zm8,4a1,1,0,0,1-1-1v-8a1,1,0,0,1,2,0v8A1,1,0,0,1,735,5659Zm4-4h-8a1,1,0,0,1,0-2h8A1,1,0,0,1,739,5655Z"
								transform="translate(-716 -5641)"
							/>
						</svg>
						<span className={classes.addMoreText}>{text.ADD_MORE_TARIFF}</span>
					</div>
				)}
				{this.props.tariffs.length == 0 && (
					<div className={classes.addMore}>
						<svg
							className={classes.addMoreIcon}
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="18"
							viewBox="0 0 24 18"
						>
							<path
								d="M731,5643H717a1,1,0,0,1,0-2h14A1,1,0,0,1,731,5643Zm0,4H717a1,1,0,0,1,0-2h14A1,1,0,0,1,731,5647Zm0,4H717a1,1,0,0,1,0-2h14A1,1,0,0,1,731,5651Zm-4,4H717a1,1,0,0,1,0-2h10A1,1,0,0,1,727,5655Zm8,4a1,1,0,0,1-1-1v-8a1,1,0,0,1,2,0v8A1,1,0,0,1,735,5659Zm4-4h-8a1,1,0,0,1,0-2h8A1,1,0,0,1,739,5655Z"
								transform="translate(-716 -5641)"
							/>
						</svg>
						<span className={classes.addMoreText}>{text.ADD_MORE_TARIFF_2}</span>
					</div>
				)}
				{this.props.tariffs.length > 1 && (
					<div className={classes.button}>{this.props.compareButton}</div>
				)}
			</div>
		);
	}
}

export default withStyles(styles)(CompareSliderWrapper);
